<swiper [config]="swiperConfigService.swiperFilhoConfig" (indexChange)="onSlideIndexChange($event)">
    <div class="swiper-slide">
        <app-llacuna-page1></app-llacuna-page1>
    </div>
    <!-- Retirado por MKT Studio para sumir com a segunda página onde estava o video. O Vídeo foi incorporado na primeira página-->
    <!--<div class="swiper-slide">
        <app-llacuna-page2 [showVideo]="showVideo"></app-llacuna-page2>
    </div>-->
</swiper>